import { render, staticRenderFns } from "./time-travel-badge.vue?vue&type=template&id=c5056432&scoped=true&"
import script from "./time-travel-badge.vue?vue&type=script&lang=ts&"
export * from "./time-travel-badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5056432",
  null
  
)

export default component.exports